import { countUpBySeconds } from "./countUp";
import { timerFormat, timerFormatDHMS } from "./timerFormat";

export const timerStr =(n,show_day=false) => {
    return timerFormat(countUpBySeconds(Math.floor(n)),show_day);
}

export const timerStrDHMS =(n,shorten=false) => {
    return timerFormatDHMS(countUpBySeconds(Math.floor(n)),shorten);
}